export default "__VITE_ASSET__DXFe1xHl__"